export const setAssetLegs = (id, legs) => ({
  type: 'SET_ASSET_LEGS',
  payload: { id, legs }
});
